<template>
  <div>
    <custom-form
      class="text-capitalize"
      :fields="transaction"
      :method="method"
      :action="url"
      @submitted="
        method === 'post'
          ? $emit('transactionCreated', $event)
          : $emit('transactionUpdated', $event)
      "
    >
      <!-- form components that only apply for transaction creation -->
      <v-row no-gutters v-if="showHiddenFields">
        <v-col cols="12" class="px-1">
          <custom-select
            name="crypto_country_id"
            class="form-group"
            label="Crypto Country"
            item-value="id"
            item-text="name"
            @changed="updateRates"
            :items="countries"
          />
        </v-col>
        <v-col cols="12" class="px-1">
          <custom-select
            ref="crypto_rates"
            name="rate_id"
            outlined
            item-value="id"
            :item-text="cryptoRateText"
            :items="selectable_rates"
            label="Crypto Rate"
          />
        </v-col>
        <v-col cols="12" class="px-1">
          <custom-input name="local_amount" label="Local Amount" />
        </v-col>
        <v-col cols="12" class="px-1">
          <custom-input name="address" label="crypto address" />
        </v-col>
      </v-row>
      <!-- global from components -->
      <v-row no-gutters>
        <v-col cols="12" class="px-1">
          <custom-user-search
            name="user_id"
            :existing_user="user"
            label="User"
            item_name="full_name"
            item_value="id"
            icon="mdi-account-search"
          />
        </v-col>
        <v-col cols="12" class="px-1">
          <custom-button block color="primary" large raised tile>
            <v-icon size="30" class="mr-2">mdi-bitcoin</v-icon>
            {{ method === "post" ? "Create" : "Update" }} Transaction
          </custom-button>
        </v-col>
      </v-row>
    </custom-form>
  </div>
</template>

<script>
export default {
  props: {
    method: {
      default: "post",
      type: String,
    },
    transaction: {
      default: () => ({
        crypto_country_id: "",
        rate_id: "",
        user_id: "",
        local_amount: "",
        address: "",
      }),
      type: Object,
    },
    user: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      countries: [],
      selectable_rates: [],
      rates: [],
      errors: [],
      rules: {
        required: (v) => !!v || "This field is required",
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    url() {
      if (this.transaction.id) {
        return `api/v1/cryptoTransactions/${this.transaction.id}`;
      }
      return `api/v1/cryptoTransactions/create`;
    },
    showHiddenFields() {
      const orderStatus = this.transaction.order_status;
      if (orderStatus === "pending" || orderStatus === "failed") {
        return true;
      }

      return this.method === "post";
    },
  },
  methods: {
    cryptoRateText(data) {
      const exchange = ` (1 ${data.reference_currency.symbol} = ${data.reference_to_local_rate} ${data.local_currency.symbol})`;
      return data.crypto_currency.name + exchange;
    },
    updateRates(crypto_country_id) {
      // reset the selection
      this.transaction.rate_id = "";

      this.selectable_rates = this.rates.filter((o) => o.crypto_country_id === crypto_country_id);
    },
    fetchData() {
      this.$http.get("/api/v1/cryptoRates").then((response) => {
        // use only bitcoin and ethereum rates
        this.rates = response.data.filter(function (rate) {
          return (
            rate.crypto_currency.short_name.toLowerCase() === "btc" ||
            rate.crypto_currency.short_name.toLowerCase() === "eth"
          );
        });
      });

      this.$http.get("/api/v1/transactions/cryptoCountries").then(({ data }) => {
        this.countries = data;
      });
    },
  },
};
</script>
